import React from 'react'
import ModalContainer from '../../../Components/UiKits/Modal'

export default function Modal() {
  return (
    <div className='page-body'>
        <ModalContainer/>
    </div>
  )
}
